import { connect } from 'react-redux'
import FoilOverview from './FoilOverview'

const mapStateToProps = () => {
    return {

    }
}

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FoilOverview)



// WEBPACK FOOTER //
// ./src/modules/foil/component/overview/FoilOverviewContainer.js